export default __webpack_public_path__ + "static/media/user.8ea00563.svg";